import React, { useEffect, useState } from 'react'

import * as S from './styles'

import ButtonDefault from '../ui/Buttons/ButtonDefault'
import ButtonPrimary from '../ui/Buttons/ButtonPrimary'
import ModalDefault from '../ui/Modals/ModalDefault'
import ToastContainer from '../ui/Toast/ToastContainer'
import ToastItem from '../ui/Toast/ToastItem'
import BoxSkeleton from '../ui/Skeleton/BoxSkeleton'
import Inputkeleton from '../ui/Skeleton/Inputkeleton'
import Input from '../ui/Form/Input'
import Loading from '../shared/Loading'

import api from '../../utils/api'

function ActiveTwoFactorModal({ active, token, setModalActive, onSuccess }) {
  const [code, setCode] = useState('')
  const [errors, setErrors] = useState({})
  const [QRCode, setQRCode] = useState(null)
  const [loadingQRCode, setLoadingQRCode] = useState(false)
  const [loadingActive, setLoadingActive] = useState(false)

  const [toastActive, setToastActive] = useState(false)
  const [toastData, setToastData] = useState(null)

  useEffect(() => {
    async function generateQRCode() {
      setLoadingQRCode(true)
      try {
        const response = await api.post('/generate-qrcode', null, { headers: { authorization: 'Bearer ' + token } })
        setQRCode(response.data.data.url)
      } catch (error) {
        setToastData({
          type: 'error',
          message: error.response.data.error.message || 'Erro ao gerar código'
        })
        setToastActive(true)
      } finally {
        setLoadingQRCode(false)
      }
    }

    if (active && token) {
      setCode('')
      setErrors({})
      generateQRCode()
    }
  }, [active, token])

  async function handleConfirmationCode() {
    setLoadingActive(true)

    const segurancaData = {
      active: true,
      code
    }

    try {
      await api.patch('/users/edit', { segurancaData }, {
        headers: {
          authorization: 'Bearer ' + token,
        }
      })

      setToastData({
        type: 'success',
        message: 'Autenticação de dois fatores ativada. Digite o código para fazer o login.'
      })

      onSuccess()
      setModalActive()
    } catch (error) {
      let message = error.response.data.error.message || 'Erro ao ativar autenticação de dois fatores'
      if (error.response.status === 406) {
        message = 'Código inválido'
        setErrors({ code: 'Erro ao confirmar o código' })
      }

      setToastData({
        type: 'error',
        message: message
      })
    } finally {
      setToastActive(true)
      setLoadingActive(false)
    }
  }

  function handleCodeChange(e) {
    if (e.target.value.length > 6) {
      return
    }

    setCode(e.target.value)
  }

  return (
    <>
      <ModalDefault
        active={active}
        title='Autenticação de dois fatores'
        onClick={() => setModalActive(false)}
      >
        <S.Container>
          <S.Title>
            A autenticação de dois fatores agora é obrigatória.
          </S.Title>

          <p>
            Para ativar a autenticação de dois fatores, baixe o aplicativo Google Authenticator e escaneie o código QR exibido abaixo usando o aplicativo.
          </p>

          <p>
            Insira o código gerado pelo aplicativo e pronto, a autenticação de dois fatores será ativada em sua conta.
          </p>

          <S.CodeContainer>
            {loadingQRCode ?
              <S.LoaderBox>
                <BoxSkeleton height='250px' />

                <Inputkeleton />
              </S.LoaderBox>
              :
              <>
                <S.QRCode
                  src={QRCode}
                  alt='QRCode autenticação de dois fatores'
                />

                <S.FlexContainer>
                  <Input
                    label='Código'
                    name='code'
                    type='number'
                    placeholder='Código mostrado no app'
                    invalid={errors.code}
                    invalidText={errors.code}
                    value={code}
                    onChange={handleCodeChange}
                    required
                  />
                </S.FlexContainer>
              </>
            }

          </S.CodeContainer>
        </S.Container>

        <S.Separator />

        <S.FlexEndContainer>
          <S.ButtonContainer>
            <ButtonDefault
              upperCase
              size='md'
              text='Cancelar'
              disabled={loadingActive}
              onClick={() => setModalActive(false)}
            />
          </S.ButtonContainer>

          <S.ButtonContainer>
            <ButtonPrimary
              upperCase
              size='md'
              text='Confirmar'
              disabled={loadingActive || code.length !== 6}
              onClick={handleConfirmationCode}
            />
          </S.ButtonContainer>
        </S.FlexEndContainer>
      </ModalDefault>

      <Loading active={loadingActive} />

      {toastActive && (
        <ToastContainer>
          <ToastItem
            type={toastData.type}
            text={toastData.message}
            setToastActive={setToastActive}
            onClick={() => setToastActive(false)}
          />
        </ToastContainer>
      )}
    </>
  )
}

export default ActiveTwoFactorModal
